import { useTilgang } from '../skall/tilgang.ts';
import { Ikon } from '../status/Ikon.tsx';

/**
 * Et medlem på direkte rute til Organisasjon eller en av undersidene (DD-01, DD-68). Ingen
 * feilfarge — det er ikke en feil — og ingenting hentes: lista over panelbrukere finnes aldri
 * for andre enn eier. Rollen i ordet kommer fra `access`, aldri fra `role` (M4.8).
 */
export function BareEier() {
  const { rolletekst } = useTilgang();
  return (
    <>
      <header className="panel-topp">
        <h1 className="panel-h1">Denne siden er for eier</h1>
      </header>
      <div className="panel-innst">
        <p className="panel-tekst">Du er {rolletekst ?? 'medlem'}.</p>
        <p className="panel-tekst">
          <a href="/innboks" className="panel-knapp-lenke">
            <Ikon navn="arrow-back-outline" /> Til innboksen
          </a>
        </p>
      </div>
    </>
  );
}
